// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"703":"73940452","919":"415beecf"}[chunkId] + ".chunk.js";
};